export default {
  text: 'Nurturing',
  thumbnail:
    'https://vastreach.com/static_assets/email/thumnails/Nurturing_email_1.jpg',
  snippets: {
    Button: {
      icon: 'RadioButton',
      text: 'Button',
      editor: 'button',
      html: '<!-- Dynamic WYSIWYG Content --><div style="max-width: 600px;margin: 0 auto 0;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;"><p style="text-align: center;margin:0;"><a data-button-text="Start now" data-button-url="https://www.vastreach.com" data-button-color="#ffffff" data-button-background-color="#00e919" href="#" target="_blank"><button style="color: #ffffff; background-color: #00e919;border: 0; padding: 15px 25px; margin: 0; border-radius: 0.3rem; cursor: pointer;"><strong>Start Now</strong></button></a></p></div><!-- End of Dynamic WYSIWYG Content -->',
    },
    Social: {
      icon: 'Share',
      text: 'Social',
      editor: 'social-media',
      html: '<!-- Dynamic WYSIWYG Content --><table style="margin: 0 auto;background: transparent;" border="0" cellpadding="0" cellspacing="0" align="center"><tr><td width="600" align="center"><table style="margin: 20px 0 20px 0;"><tr><td align="center"> <a data-social-media="facebook" href="https://www.facebook.com/" target="_blank"><img src="https://vastreach.com/static_assets/facebook.png" border="0" style="background-color: #00b0e5; padding: 4px; border-radius:28px;" /></a> </td><td align="center"> <a data-social-media="instagram" href="https://www.instagram.com/" target="_blank"><img src="https://vastreach.com/static_assets/instagram.png" border="0" style="background-color: #00b0e5;padding: 4px; border-radius:28px;" /></a> </td><td align="center"> <a data-social-media="twitter" href="https://twitter.com/" target="_blank"><img src="https://vastreach.com/static_assets/twitter.png" border="0" style="background-color: #00b0e5;padding: 4px; border-radius:28px;" /></a> </td></tr></table></td></tr></table><!-- End of Dynamic WYSIWYG Content -->',
    },
    Paragraph: {
      icon: 'Notes',
      text: 'Paragraph',
      editor: 'wysiwyg',
      html: `<!-- Dynamic WYSIWYG Content --><div style="max-width: 600px;margin: 0 auto 0;padding: 10px 20px;text-align: center;background: transparent;"> <span style="font-size: medium;color:#000000;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">We have over 40 Hot Tubs & Swim Spas on Display from Major Brands and Everything Must Go! </span></div><!-- End of Dynamic WYSIWYG Content -->`,
    },
    'Image Banner + Text': {
      icon: 'Satellite',
      text: 'Image Banner + Text',
      editor: 'wysiwyg',
      html: '<!-- Dynamic WYSIWYG Content --><table border="0" cellpadding="0" cellspacing="0" style="width: 100%; max-width: 600px; margin: 0 auto; padding: 0; text-align: center; background-color: #ffffff;"><tr><td valign="middle" style="background-image: url(https://vastreach.com/static_assets/snippets/customer_support.jpg);background-position: center center !important;background-size: cover !important;text-align: center;background-repeat: no-repeat;padding: 50px 0 50px 0;background-position: center;background-size: cover;"><table border="0" cellpadding="0" cellspacing="0" style="width: 100%;"><tr><td valign="middle" style="text-align: center; padding: 50px 50px 50px; font-size: 15px; line-height: 20px; color: #ffffff;"><h2 style="font-size: 35px; font-weight: 600; font-family: Tahoma, Geneva, sans-serif; word-wrap: break-word; line-height: 1.5; display: inline-block; vertical-align: middle;">YOUR STATEMENT <b style="color: #00b0e5;">HERE</b></h2><p style="margin: 0; color: #ffffff; font-size: 14px; font-weight: 550; font-family: Arial, Helvetica, sans-serif;">Place a description or your mission statement here. We recommend using a darker image on lighter text or lighter image on darker text.</p></td></tr></table></td></tr></table><!-- End of Dynamic WYSIWYG Content -->',
    },
  },
  value: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" style="width: 100%;height: 100%;margin: 0;padding: 0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">

<head>
  <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
  <meta name="viewport" content="width=device-width"/>
  <meta class="vastreach-theme" data-vast-theme="nurturing"/>
</head>	

<body align="center" style="margin: 0;padding:0;background-color: #ffffff;">
  <div class="background" style="background: #ffffff;">
    <div class="foreground" style="max-width: 600px;background: #ffffff;">
		<table style="max-width: 600px;margin: 0 auto 0;padding: 0 0 20px 0;text-align: center;border-radius: .35rem;border-spacing: 0;">
		<tr>
			<td class="vastreach-sections" data-vast-editor="img-picker" style="padding: 0;">
				<!-- Dynamic WYSIWYG Content -->
				<div style="max-width: 600px;margin: 0 auto;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">		
					<img src="https://vastreach.com/static_assets/email/nurturing_v1/beta-logo.png" alt="logo" style="width: 100%;max-width: 200px;margin: 0 auto;display: block;">
				</div> 
				<!-- End of Dynamic WYSIWYG Content -->						  
			</td>	
		</tr>	

		<tr>	
			<td class="vastreach-sections" data-vast-editor="img-picker" style="padding: 0;">
				<!-- Dynamic WYSIWYG Content -->
				<div style="max-width: 600px;margin: 0 auto;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">		
					<img src="https://vastreach.com/static_assets/email/nurturing_v1/car_with_wheels.jpg" alt="car with nice wheels" style="max-width: 100%;margin: 0 auto;display: block;">
				</div> 
				<!-- End of Dynamic WYSIWYG Content -->
			</td>	
		</tr>

		<tr>
			<td class="vastreach-sections" data-vast-editor="paragraph" style="padding: 0;">
				<!-- Dynamic WYSIWYG Content -->
				<div style="max-width: 600px;margin: 0 auto;padding: 20px;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">		
					<h1 style="margin: 0;"><span style="font-size: xx-large;font-family: Arial, Helvetica, sans-serif;">Thank you for your purchase!</span></h1>
				</div> 
				<!-- End of Dynamic WYSIWYG Content -->
			</td>	
		</tr>

		<tr>
			<td class="vastreach-sections" data-vast-editor="paragraph" style="padding: 0;">
				<!-- Dynamic WYSIWYG Content -->
				<div style="max-width: 600px;margin: 0 auto;padding: 10px;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">	
					<h2 style="margin: 0;"><span style="font-size: large;font-family: Arial, Helvetica, sans-serif;">Not sure how to install your new wheels?<br />Don't panic! We got your back!</span></h2>
				</div> 
				<!-- End of Dynamic WYSIWYG Content -->
			</td>	
		</tr>	  

		<tr>
			<td class="vastreach-sections" data-vast-editor="paragraph" style="padding: 0;">
				<!-- Dynamic WYSIWYG Content -->
				<div style="max-width: 600px;margin: 0 auto 0;padding: 10px 20px;text-align: center;background: transparent;">        
					<span style="font-size: medium;color:#000000;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">We answered all of the questions our customers typically ask us about installing your brand new tires or wheels. We compiled all of that information and more in an FAQ page just to help our customers get started. Click below for more information.</span>
				</div>
				<!-- End of Dynamic WYSIWYG Content -->
			</td>	
		</tr>	  

		<tr>
			<td class="vastreach-sections" data-vast-editor="button" style="padding: 0;">
				<!-- Dynamic WYSIWYG Content -->
				<div style="max-width: 600px;margin: 0 auto 0;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
					<p style="text-align: center;margin:0;">
						<a data-button-text="Educate Me" data-button-url="#" data-button-color="#ffffff" data-button-background-color="#00e919" href="#" target="_blank">
							<button style="color: #ffffff; background-color: #00e919;border: 0; padding: 15px 25px; margin: 0; border-radius: 0.3rem; cursor: pointer;"><strong>Educate Me</strong></button>
						</a>
					</p>
				</div>
				<!-- End of Dynamic WYSIWYG Content -->
			</td>	
		</tr>		  

		<tr>
			<td class="vastreach-sections" data-vast-editor="paragraph" >
				<!-- Dynamic WYSIWYG Content -->
				<div style="max-width: 600px;margin: 0 auto;padding: 10px 20px;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">	
					<hr>
				</div> 
				<!-- End of Dynamic WYSIWYG Content -->
			</td>									
		</tr>	

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph" dir="ltr" valign="top" width="100%" style="padding: 0;">
					<!-- Dynamic WYSIWYG Content -->
					<table style="width: 100%;max-width: 600px;margin: 0 auto;padding: 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
						<tr>
							<td>			  
								<table border="0" cellpadding="0" cellspacing="0" width="100%" style="padding: 30px 20px 30px 20px;border-spacing: 0;">
									<tr>
										<td valign="top" width="33.33%">
											<table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-spacing: 0;">
												<tr>
													<td dir="ltr" valign="top" style="padding: 0 15px 15px 0">
														<img src="https://vastreach.com/static_assets/email/nurturing_v1/step1.jpg" alt="step 1 wheel change" style="max-width: 100%;margin: 0 auto;display: block;">
													</td>
												</tr>
											</table>
										</td>
										<td valign="top" width="66.66%">
											<table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-spacing: 0;">
												<tr>
													<td dir="ltr" valign="top" style="text-align: left;">
														<h2><span style="font-size: large;font-family: Arial, Helvetica, sans-serif;">STEP 1:</span></h2>
														<span style="font-size: medium;color:#000000;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Make sure you have non-inflated tire if it's a spare. Prepare your tools, usually found inside your car’s trunk or with/behind the spare.</span>
													</td>
												</tr>
											</table>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</table>
					<!-- End of Dynamic WYSIWYG Content -->
				</td>
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph" dir="rtl" valign="top" width="100%" style="padding: 0;">
					<!-- Dynamic WYSIWYG Content -->
					<table style="width: 100%;max-width: 600px;margin: 0 auto;padding: 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
						<tr>
							<td>			  
								<table border="0" cellpadding="0" cellspacing="0" width="100%" style="padding: 30px 20px 30px 20px;border-spacing: 0;">
									<tr>
										<td valign="top" width="66.66%">
											<table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-spacing: 0;">
												<tr>
													<td dir="ltr" valign="top" style="text-align: left;">
														<h2><span style="font-size: large;font-family: Arial, Helvetica, sans-serif;">STEP 2:</strong></h2>
														<span style="font-size: medium;color:#000000;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Unscrew your lug nuts on your wheel using the tire iron rod tool. If you have an extender or breaker-bar you may need to use that for more leverage. Place the removed lug nuts in a safe place for later.</span>
													</td>
												</tr>
											</table>
										</td>	                  	
										<td valign="top" width="33.33%">
											<table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-spacing: 0;">
												<tr>
													<td dir="ltr" valign="top" style="padding: 0 0 15px 15px">
														<img src="https://vastreach.com/static_assets/email/nurturing_v1/step2.jpg" alt="step 2 wheel change" style="max-width: 100%;margin: 0 auto;display: block;">
													</td>
												</tr>
											</table>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</table>
					<!-- End of Dynamic WYSIWYG Content -->
				</td>
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph" dir="ltr" valign="top" width="100%" style="padding: 0;">
					<!-- Dynamic WYSIWYG Content -->
					<table style="width: 100%;max-width: 600px;margin: 0 auto;padding: 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
						<tr>
							<td>			  
								<table border="0" cellpadding="0" cellspacing="0" width="100%" style="padding: 30px 20px 30px 20px;border-spacing: 0;">
									<tr>
										<td valign="top" width="33.33%">
											<table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-spacing: 0;">
												<tr>
													<td dir="ltr" valign="top" style="padding: 0 15px 15px 0">
														<img src="https://vastreach.com/static_assets/email/nurturing_v1/step3.jpg" alt="step 3 wheel change" style="max-width: 100%;margin: 0 auto;display: block;">
													</td>
												</tr>
											</table>
										</td>
										<td valign="top" width="66.66%">
											<table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-spacing: 0;">
												<tr>
													<td dir="ltr" valign="top" style="text-align: left;">
														<h2><span style="font-size: large;font-family: Arial, Helvetica, sans-serif;">STEP 3:</span></h2>
														<span style="font-size: medium;color:#000000;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Once you remove your old wheel, equip your new wheel and manually screw in the lug nuts by hand until the wheel is held in place without your assistance. Next using your tire iron rod tool, screw the lug nuts in tightly using a star pattern for an even and safe fit. Done!</span>
													</td>
												</tr>
											</table>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</table>
					<!-- End of Dynamic WYSIWYG Content -->
				</td>
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph" style="padding: 0;">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto;padding: 10px 20px;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">			  
						<hr>
						<span style="font-size: medium;color:#000000;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">FREE SHIPPING & 3-DAY DELIVERY GUARANTEED</span>
						<hr>
					</div>
					<!-- End of Dynamic WYSIWYG Content -->
				</td>	
			</tr>	      

		<tr>
			<td class="vastreach-sections" data-vast-editor="social-media" style="padding: 20px 0;">
				<!-- Dynamic WYSIWYG Content -->
				<table style="margin: 0 auto;background: transparent;" border="0" cellpadding="0" cellspacing="0" align="center">
				<tr>
					<td width="600" align="center">
						<table style="margin: 20px 0 20px 0;">
							<tr>
							<td align="center"> <a data-social-media="facebook" href="https://www.facebook.com/" target="_blank"><img src="https://vastreach.com/static_assets/facebook.png" border="0" style="background-color: #00b0e5; padding: 4px; border-radius:28px;" /></a> </td>
							<td align="center"> <a data-social-media="instagram" href="https://www.instagram.com/" target="_blank"><img src="https://vastreach.com/static_assets/instagram.png" border="0" style="background-color: #00b0e5;padding: 4px; border-radius:28px;" /></a> </td>
							<td align="center"> <a data-social-media="twitter" href="https://twitter.com/" target="_blank"><img src="https://vastreach.com/static_assets/twitter.png" border="0" style="background-color: #00b0e5;padding: 4px; border-radius:28px;" /></a> </td>
							</tr>
						</table>
					</td>
				</tr>
				</table>	
				<!-- End of Dynamic WYSIWYG Content -->
			</td>	
		</tr>		                					
		</table>    
	</div>					
</div>					
</body>	
</html>`,
}
